import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pm9cgrtuwg: FaireBrandEntity = {
  token: "b_pm9cgrtuwg",
  type: "brand",
  name: "Mack & Rex",
  avatarUrl:
    "https://cdn.faire.com/fastly/2745149c2e1e9642cc1f37c1a21cbffc12cca9c7672eae9ecdc7375669d3a752.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/126c68787f0c8c72951e937e695bb84308af8497343618f1ef268a494a395e95.png",
  logoUrl:
    "https://cdn.faire.com/fastly/2745149c2e1e9642cc1f37c1a21cbffc12cca9c7672eae9ecdc7375669d3a752.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/126c68787f0c8c72951e937e695bb84308af8497343618f1ef268a494a395e95.png",
  location: "Spanish Fork, UT, USA",
  minimumOrderDollars: 172,
  rating: 5,
  reviewCount: 19,
  isInsider: true,
  description:
    "Seeing the need for INCLUSIVE SIZING (XXS through 5XL) in the tile bracelet industry, Mack & Rex came to life in 2020 to fulfill that need. \n\nIn a few short years, our business has turned into a full scale warehouse operation, not only making and selling bracelets, but we also offer diy bracelet kits, necklaces, and earrings. It’s success is based on one thing ‘Create the things you wished existed’ Mack & Rex takes on custom orders or designs for businesses. We DO NOT have a store front, so we rely on other businesses to sell our bracelets. \n\nThe designs of Mack & Rex bracelets are unique, fresh, and always on trend. Mack & Rex takes pride in not needing to copy other designs to be successful - they are ahead of the game and release new designs each month ahead of schedule. \n\nMack & Rex tile bracelets are made with a crystal cord elastic, high quality pressed glass Japanese beads, and tarnish proof findings. Mack & Rex bracelets are waterproof, light, comfortable & extremely durable. ",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:09.784Z",
    importedBy: "entity-db-cli",
  },
};
